<script setup lang="ts"></script>
<template>
  <footer class="site-footer">
    <div class="footer-logo">
      <img class="logo-image" src="./images/logo.svg" alt="Logo" />
    </div>
    <div class="footer-links-first">
      <NuxtLink to="/" class="website-link">www.cre.ru</NuxtLink>
      <NuxtLink to="https://t.me/CRERussia" target="_blank" class="social-item">
        Телеграм
        <img src="./images/link-arrow.svg" alt="Arrow" />
      </NuxtLink>
      <NuxtLink
        to="https://vk.com/cre.russia"
        target="_blank"
        class="social-item"
      >
        ВК
        <img src="./images/link-arrow.svg" alt="Arrow" />
      </NuxtLink>
      <NuxtLink
        to="https://max.ru/join/NNC7Swp5Eg60kaZl4h3rH4Fg2Xt03lx10SnBKi7JKdk"
        target="_blank"
        class="social-item"
      >
        Макс
        <img src="./images/link-arrow.svg" alt="Arrow" />
      </NuxtLink>
    </div>
    <div class="footer-links-second">
      <div class="footer-copyright">© CRE 2026, все права защищены</div>
      <div class="footer-legal-links">
        <NuxtLink
          to="https://cre.ru/politika-konfidentsialnosti"
          target="_blank"
          class="legal-link"
        >
          Политика конфиденциальности
        </NuxtLink>
        <NuxtLink
          to="https://cre.ru/privacy_policy"
          target="_blank"
          class="legal-link"
        >
          Согласие на обработку персональных данных
        </NuxtLink>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.site-footer {
  position: relative;
  padding: 0 30px 30px;

  @media (max-width: $mobile-view) {
    padding: 0 20px 20px;
  }

  .footer-logo {
    padding: 30px 0;
    box-sizing: border-box;
    width: 100%;

    @media (max-width: $mobile-view) {
      padding: 0 0 20px 0;
    }

    .logo-image {
      width: 100%;
    }
  }

  .footer-links-first {
    display: flex;
    padding-bottom: 30px;
    border-bottom: 2px solid #999999;

    @media (max-width: $mobile-view) {
      padding-bottom: 20px;
    }

    .website-link {
      color: #111111;
      @include font-regular;
      font-size: 22px;
      line-height: 130%;
      text-decoration: none;

      @media (max-width: $mobile-view) {
        font-size: 14px;
      }
    }

    .social-item:nth-child(2) {
      margin-left: auto;
    }

    .social-item {
      display: flex;
      gap: 20px;
      align-items: center;
      @include font-regular;
      font-size: 22px;
      line-height: 130%;
      color: #111111;
      text-decoration: none;
      margin-left: 30px;

      @media (max-width: $mobile-view) {
        font-size: 16px;
      }
    }
  }

  .footer-links-second {
    display: flex;
    padding-top: 30px;

    @media (max-width: $mobile-view) {
      padding-bottom: 20px;
      flex-direction: column;
      gap: 10px;
    }

    .footer-copyright {
      color: #313030;
      @include font-regular;
      font-size: 14px;
    }

    .footer-legal-links {
      display: flex;
      gap: 15px;
      margin-left: auto;

      @media (max-width: $mobile-view) {
        flex-direction: column;
        gap: 10px;
        margin-left: 0;
      }

      .legal-link {
        color: #313030;
        @include font-regular;
        font-size: 14px;
        text-decoration: none;
      }
    }
  }
}
</style>
